import { createApi } from '@reduxjs/toolkit/query/react';
// Import all API endpoint modules
import { beamstarApiEndpoints } from './api/beamstar-api';
import { blobApiEndpoints } from './api/blob-api';
import { buildingPackageApiEndpoints } from './api/building-package-api';
import { chatApiEndpoints } from './api/chat-api';
import { dashboardApiEndpoints } from './api/dashboard-api';
import { documentPackageApiEndpoints } from './api/document-package-api';
import { documentPackageResultApiEndpoints } from './api/document-package-result-api';
import { documentPackageSummaryApiEndpoints } from './api/document-package-summary-api';
import { exportApiEndpoints } from './api/export-api';
import { feedbackApiEndpoints } from './api/feedback-api';
import { fileApiEndpoints } from './api/file-api';
import { findingApiEndpoints } from './api/finding-api';
import { geocodingApiEndpoints } from './api/geocoding-api';
import { layoutOptimizationApiEndpoints } from './api/layout-optimization-api';
import { localeApiEndpoints } from './api/locale-api';
import { meetingApiEndpoints } from './api/meeting-api';
import { notificationApiEndpoints } from './api/notification-api';
import { oracleApiEndpoints } from './api/oracle-api';
import { organizationApiEndpoints } from './api/organization-api';
import { pipelineDashboardApiEndpoints } from './api/pipeline-dashboard-api';
import { processorJobApiEndpoints } from './api/processor-job-api';
import { projectApiEndpoints } from './api/project-api';
import { qaSubmissionApiEndpoints } from './api/qa-submission-api';
import { reportTemplateApiEndpoints } from './api/report-template-api';
import { tagTypes } from './api/shared/types';
import { structuralEngineeringApiEndpoints } from './api/structural-engineering-api';
import { userApiEndpoints } from './api/user-api';
import { versionCompareApiEndpoints } from './api/version-compare-api';
export const createApiClient = ({ baseQuery, coreApiBaseUrl, chatApiBaseUrl, meetingApiBaseUrl, buildingAgentBaseUrl, }) => {
    return createApi({
        reducerPath: 'consigliApi',
        baseQuery: baseQuery,
        tagTypes,
        endpoints: (builder) => ({
            ...projectApiEndpoints(builder, coreApiBaseUrl),
            ...documentPackageApiEndpoints(builder, coreApiBaseUrl),
            ...documentPackageResultApiEndpoints(builder, coreApiBaseUrl),
            ...documentPackageSummaryApiEndpoints(builder, coreApiBaseUrl),
            ...blobApiEndpoints(builder, coreApiBaseUrl),
            ...findingApiEndpoints(builder, coreApiBaseUrl),
            ...feedbackApiEndpoints(builder, coreApiBaseUrl),
            ...fileApiEndpoints(builder, coreApiBaseUrl),
            ...exportApiEndpoints(builder, coreApiBaseUrl),
            ...geocodingApiEndpoints(builder),
            ...layoutOptimizationApiEndpoints(builder, coreApiBaseUrl),
            ...localeApiEndpoints(builder, coreApiBaseUrl),
            ...structuralEngineeringApiEndpoints(builder, coreApiBaseUrl),
            ...buildingPackageApiEndpoints(builder, coreApiBaseUrl),
            ...organizationApiEndpoints(builder, coreApiBaseUrl),
            ...userApiEndpoints(builder, coreApiBaseUrl),
            ...processorJobApiEndpoints(builder, coreApiBaseUrl),
            ...reportTemplateApiEndpoints(builder, coreApiBaseUrl),
            ...chatApiEndpoints(builder, chatApiBaseUrl),
            ...meetingApiEndpoints(builder, meetingApiBaseUrl),
            ...beamstarApiEndpoints(builder, buildingAgentBaseUrl),
            ...dashboardApiEndpoints(builder, coreApiBaseUrl),
            ...pipelineDashboardApiEndpoints(builder, coreApiBaseUrl),
            ...notificationApiEndpoints(builder, coreApiBaseUrl),
            ...oracleApiEndpoints(builder, coreApiBaseUrl),
            ...qaSubmissionApiEndpoints(builder, coreApiBaseUrl),
            ...versionCompareApiEndpoints(builder, coreApiBaseUrl),
        }),
    });
};
